/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber3 = createReactComponent("number-3", "IconNumber3", [
  ["path", { d: "M12 12a4 4 0 1 0 -4 -4", key: "svg-0" }],
  ["path", { d: "M8 16a4 4 0 1 0 4 -4", key: "svg-1" }]
]);

export { IconNumber3 as default };
//# sourceMappingURL=IconNumber3.js.map
